import { ApiHelper } from '../../../../common/helpers/ApiHelper'
import { withVendorProjectIdQueryParam } from '../WhatsappUtils'

export const LOADING_FLOW_OPTIONS = [{ key: '', label: 'Loading…' }]

function flowItemToSelectOption(item) {
  const name = String((item && item.name) || '').trim()
  if (!name) return null
  return { key: name, label: name }
}

export async function fetchWhatsappFlowOptionsForNumber(ms, orgId, fromNumber, crmNumbers) {
  if (!fromNumber) return []
  const data = await ApiHelper.callAwait({
    ms,
    method: 'GET',
    paths: ['hooks'],
    queryParams: withVendorProjectIdQueryParam(
      { orgId, fromNumber, bridgePath: 'whatsappflows' },
      fromNumber,
      crmNumbers
    ),
  })
  return ((data && data.items) || [])
    .map(flowItemToSelectOption)
    .filter(Boolean)
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
}
